module.exports = __webpack_public_path__ + "static/RiskOfRain2-d8016c779cbf55e863894b09b4cf141e.png";